import { useEffect } from 'react';

/**
 * Shows a native browser warning when the user tries to close/refresh the tab
 * while in the middle of a screening flow.
 *
 * NOTE: Browsers ignore custom text and show their own wording, but we still
 * set a meaningful message for compatibility.
 *
 * @param {boolean} enabled - When true, warning is active.
 */
export function useScreeningLeaveWarning(enabled = true) {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    const message =
      'Changes you made may not be saved. Refreshing or closing this page may auto-submit your assessment and affect your progress.';

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // Some browsers require returnValue to be set.
      // eslint-disable-next-line no-param-reassign
      event.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enabled]);
}

